import store from '@/store'

export default [
  {
    path: '/fee-setups',
    name: 'fee-setup',
    meta: { requiresAuth: true },
    component: () => import('@/pages/fee-setup/index-v2.vue')
  },
  {
    path: '/fee-setups/create',
    name: 'fee-setup-create',
    meta: { requiresAuth: true },
    component: () => import('@/pages/fee-setup/create.vue')
  },
  {
    path: '/fee-setups/:id',
    name: 'fee-setup-edit',
    meta: { requiresAuth: true },
    component: () => import('@/pages/fee-setup/edit.vue'),
    beforeEnter: async (to, from, next) => {
      await store.dispatch('feeSetup/find', to.params.id)
      next()
    }
  },
  {
    path: '/fee-setups/:id/copies',
    name: 'fee-setup-copy',
    meta: { requiresAuth: true },
    component: () => import('@/pages/fee-setup/copy.vue'),
    beforeEnter: async (to, from, next) => {
      await store.dispatch('feeSetup/find', to.params.id)
      next()
    }
  }
]
